<template>
  <div
    id="ps-connect"
    class="ps-connect"
    @mousemove="moveLine($event, currentLineId)"
    @touchmove="moveLine($event, currentLineId, true)"
    @mouseup="endConnect($event, currentLineId)"
    @touchend="endConnect($event, currentLineId, true)"
    @click="clickAnywhere"
  >
    <div v-if="drag" id="transparent-container" class="transparent-container"></div>

    <div v-for="(staticImage, index) in staticImages" :key="index">
      <div
        :style="{
          position: 'absolute',
          top: staticImage.pos.y + 'px',
          left: staticImage.pos.x + 'px',
          width: staticImage.width + 'px',
          height: staticImage.height + 'px',
        }"
      >
        <img class="item-image" :src="giveMeImagePlease(staticImage.src)" alt="" />
      </div>
    </div>
    <tr-static-text
      :static-text="item"
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
    >
    </tr-static-text>
    <img :src="giveMeImagePlease(mainImage)" alt="" />

    <div v-for="item in items" :key="item.id">
      <mz-mask-in-game
        :key="data.top + data.left + 'mask' + index"
        v-for="(data, index) in startGameConfig.staticMaskConfig"
        :item-data="data"
        :mask-data="maskData"
        @change-item-mask="changeItemMask"
        style="z-index: 3"
      ></mz-mask-in-game>
      <mb-audio-in-game
        :key="data.top + data.left + 'audio' + index"
        v-for="(data, index) in audioData(item.audio)"
        :item-data="data"
        :id="data.id"
        :mask-data="maskData"
        @change-item-mask="changeItemMask"
        style="z-index: 3"
        :style="{
          top: item.pos.y + data.pos.y + 'px',
          left: item.pos.x + data.pos.x + 'px',
        }"
      ></mb-audio-in-game>
      <div
        :style="{
          top: item.pos.y + 'px',
          left: item.pos.x + 'px',
          width: item.pos.width + 'px',
          height: item.pos.height + 'px',
        }"
        class="item-container"
        @mousedown="setStartPosition($event, item.connectId, item.pos.x, item.pos.y, item.hooks, item)"
        @touchstart="setStartPosition($event, item.connectId, item.pos.x, item.pos.y, item.hooks, item, true)"
      ></div>
      <div
        :style="{
          top: item.pos.y + 'px',
          left: item.pos.x + 'px',
          width: item.pos.width + 'px',
          height: item.pos.height + 'px',
          ...item.cssStyle,
        }"
        style="opacity: 1; z-index: 1"
        class="item-container"
      >
        <div style="position: absolute; width: 100%; height: 100%" v-for="(hook, index) in item.hooks" :key="index">
          <div
            v-if="item.hookPoint"
            :style="{
              position: 'relative',
              top: hook.y - item.hookPoint.rad / 2 + 'px',
              left: hook.x - item.hookPoint.rad / 2 + 'px',
              width: item.hookPoint.rad + 'px',
              height: item.hookPoint.rad + 'px',
              ...item.hookPoint.cssStyle,
            }"
            class="circle"
          ></div>
        </div>

        <img
          draggable="false"
          :style="[{ ...item.imageStyle }]"
          class="item-image"
          v-if="item.image"
          :src="giveMeImagePlease(item.image.src)"
          alt=""
        />
        <span v-if="item.text" :style="[{ ...item.textStyle }]" class="text-container">
          <ps-text :font-size="`${isKatexFontSize}`" :text-value="`${item.text}`" v-if="isKatexFontSize"></ps-text>
          <ps-text :text-value="`${item.text}`" v-else></ps-text>
        </span>
      </div>
    </div>
    <svg
      :style="{ zIndex: LinesIndex }"
      :viewBox="'0 0 ' + windowWidth + ' ' + windowHeight"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        style="cursor: pointer; z-index: 0"
        v-for="line in lines"
        :key="line.id"
        stroke-linecap="round"
        :stroke-width="line.lineSize"
        :x1="line.x1"
        :y1="line.y1"
        :x2="line.x2"
        :y2="line.y2"
        :stroke="line.color"
        @click="removeLine(line.id)"
      />
    </svg>
    <svg
      v-if="currentLineId && drag"
      :style="{ zIndex: 1 }"
      :viewBox="'0 0 ' + windowWidth + ' ' + windowHeight"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        style="cursor: pointer; z-index: 0"
        stroke-linecap="round"
        :stroke-width="findLine(currentLineId).lineSize"
        :x1="findLine(currentLineId).x1"
        :y1="findLine(currentLineId).y1"
        :x2="findLine(currentLineId).x2"
        :y2="findLine(currentLineId).y2"
        :stroke="findLine(currentLineId).color"
        @click="removeLine(findLine(currentLineId).id)"
      />
    </svg>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import TrStaticText from '../TrInput/TrStaticText';
import * as utils from '../../Utils/inputUtils';
import PsText from '../TrInput/PsText';
import mzMaskInGame from '../../../../MzMask/MzMaskInGame';
import mbAudioInGame from '../../../../MbAudioModal/MbAudioInGame';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  //Witaj w PSCONNECT - jak modyfikujesz to zostaw porządek w kodzie i zaktualizuj dokumentację - downloadzie :)
  name: 'ps-connect',
  mixins: [defaultMixin],
  components: { PsText, TrStaticText, mzMaskInGame, mbAudioInGame },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      maskData: [],
      uncoverAllMasks: false,
      staticImages: [],
      disableClick: false,
      autoCheck: this.startGameConfig.autoCheck ? true : false,
      LinesIndex: this.startGameConfig.linesAboveItems ? 1 : 0,
      checkIfAllCorrect: this.startGameConfig.checkIfAllCorrect ? true : false,
      dontCheckIncorrectLines: this.startGameConfig.dontCheckIncorrectLines ? true : false,
      dontAcceptIncorrectLines: this.startGameConfig.dontAcceptIncorrectLines ? true : false,
      currentSourceItem: null,
      currentLineId: null,
      staticText: [],
      question: true,
      drag: false,
      lines: [],
      items: [],
      rules: null,
      multiconnect: false,
      mainImage: '',
      linesSize: 5,
      audioSounds: null,
      linesColors: {
        bad: 'red',
        good: 'green',
        neutral: 'black',
      },
    };
  },

  beforeMount() {
    this.setAudioConfig();
  },
  mounted() {
    this.init();
  },

  computed: {
    isKatexFontSize() {
      if (this.katexFontSize) {
        return this.katexFontSize;
      } else {
        return null;
      }
    },
    windowWidth: function () {
      return 1920;
    },
    windowHeight: function () {
      return 1080;
    },
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());

        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
  beforeDestroy() {
    this.resetGameAction();
  },
  methods: {
    clickAnywhere() {
      if (this.gameCheckSwitch) this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    setAudioConfig() {
      if (this.startGameConfig.sounds) {
        this.audioSounds = {};
        this.startGameConfig.sounds.forEach((el) => {
          this.audioSounds[el.id] = new Howl({
            src: this.giveMeImagePlease(el.src),
            loop: false,
            volume: 0.5,
          });
        });
      }
    },
    changeItemMask(value) {
      if (this.maskData.length > 0) {
        this.maskData = value.item;
        this.checkIfLocked();
      }
    },
    checkIfLocked() {
      if (this.maskData.length > 0) {
        if (this.uncoverAllMasks) {
          if (this.maskData.filter((el) => el.isWrapped === true).length == 0) this.disableClick = false;
          else this.disableClick = true;
        } else {
          if (this.maskData.filter((el) => el.isWrapped === true).length < this.maskData.length)
            this.disableClick = false;
          else this.disableClick = true;
        }
      }
    },
    audioData(id) {
      if (!this.startGameConfig.mbAudioItemData) return null;
      return this.startGameConfig.mbAudioItemData.filter((el) => el.id === id);
    },
    findLine(lineId) {
      return this.lines[this.findLineIndex(lineId)];
    },
    /**
     * mieszanie pozycji itemów w grupach
     * @method shuffleItems
     */
    shuffleItems() {
      this.startGameConfig.groups.forEach((group) => {
        if (!group.disableShuffle) {
          const shuffledItems = _.shuffle(_.cloneDeep(group.items));

          for (let i = 0; i < group.items.length; i++) {
            group.items[i].pos = shuffledItems[i].pos;
          }
        }
      });
    },
    /**
     * wyciągnij itemy z grup i dopisz do nich pola z grupy
     * @method prepareItems
     */
    prepareItems() {
      this.shuffleItems();
      this.startGameConfig.groups.forEach((group) => {
        let groupItems = group.items.map((item) => {
          item.group = group.name;
          if (group.cssStyle && !item.cssStyle) {
            item.cssStyle = group.cssStyle;
          }
          //uniklany id itemu
          item.id = this.getRandomId();
          //tu bedą umieszczane unikalne id linii, które są podłączone do tego itemu
          item.connectedLinesIds = [];
          return item;
        });
        this.items.push(...groupItems);
      });
    },
    init() {
      if (this.startGameConfig.uncoverAllMasks) {
        this.uncoverAllMasks = this.startGameConfig.uncoverAllMasks;
      }
      this.prepareItems();
      if (this.startGameConfig.rules) {
        this.rules = this.startGameConfig.rules;
      }

      this.multiconnect = this.startGameConfig.multiconnect;
      this.transformNamedHooksIntoHooks();
      this.insertGlobalItemsConfig();
      if (this.startGameConfig.mainImage) {
        this.mainImage = _.cloneDeep(this.startGameConfig.mainImage.src);
      }
      if (this.startGameConfig.staticImages) {
        this.staticImages = _.cloneDeep(this.startGameConfig.staticImages);
      }
      if (this.startGameConfig.linesStyle) {
        this.linesColors = this.startGameConfig.linesStyle.colors;
        this.linesSize = this.startGameConfig.linesStyle.size;
      }
      let staticText = [];
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
        staticText = this.startGameConfig.staticText;
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      if (this.startGameConfig.mbAudioItemData) {
        this.maskData = this.startGameConfig.mbAudioItemData
          .filter((d) => d.hasOwnProperty('maskConfig'))
          .map(({ id }) => ({ id: id, isWrapped: true }));
        if (this.maskData.length > 0) this.disableClick = true;
      }
      if (this.startGameConfig.staticMaskConfig) {
        this.maskData = this.startGameConfig.staticMaskConfig.map(({ id }) => ({ id: id, isWrapped: true }));
        if (this.maskData.length > 0) this.disableClick = true;
      }
    },
    deleteBadLines() {
      this.lines = this.lines.filter((line) => line.color === this.getGoodColorLine(line.connectId));
    },
    /**
     * zainicjowanie globalnych zmian dla każdego itemu
     * @method insertGlobalItemsConfig
     */
    insertGlobalItemsConfig() {
      this.items.map((item) => {
        if (this.startGameConfig.globalItemsConfig.hookPoint && !item.hookPoint) {
          item.hookPoint = this.startGameConfig.globalItemsConfig.hookPoint;
        }
        if (this.startGameConfig.globalItemsConfig.cssStyle && !item.cssStyle) {
          item.cssStyle = this.startGameConfig.globalItemsConfig.cssStyle;
        }
        return item;
      });
    },
    giveMeImagePlease(path) {
      if (path) {
        let multibookMainType = this.$store.getters.multibookType;
        return require(`__staticDir/${multibookMainType}/${path}`);
      }
    },
    /**
     * translate namedHooks into points and insert them to hooks array - set default center hook when missing hooks
     * @method transformNamedHooksIntoHooks
     */
    transformNamedHooksIntoHooks() {
      this.items.map((item) => {
        let hooks = [];
        if (item.namedHooks) {
          item.namedHooks.forEach((namedHook) => {
            switch (namedHook) {
              case 'right':
                hooks.push({ x: item.pos.width, y: item.pos.height / 2 });
                break;
              case 'left':
                hooks.push({ x: 0, y: item.pos.height / 2 });
                break;
              case 'top':
                hooks.push({ x: item.pos.width / 2, y: 0 });
                break;
              case 'bottom':
                hooks.push({ x: item.pos.width / 2, y: item.pos.height });
                break;
            }
          });
          if (item.hooks) {
            item.hooks.push(...hooks);
          } else {
            item.hooks = [...hooks];
          }
        } else if (!item.hooks) {
          let centerHook = [{ x: item.pos.width / 2, y: item.pos.height / 2 }];
          item.hooks = [...centerHook];
        }

        return item;
      });
    },
    resetGameAction() {
      if (this.maskData.length > 0) for (let m of this.maskData) m.isWrapped = true;
      this.checkIfLocked();
      this.lines = [];
      this.items = [];
      this.prepareItems();
    },

    getIncorrectLineColor(line) {
      return this.dontCheckIncorrectLines ? line.color : this.getBadColorLine(line.connectId);
    },
    getAudioIDOfCurrentConnection(item) {
      const findAudioByConnectId = (connectId) => this.items.find((el) => el.connectId === connectId)?.audioId;
      return findAudioByConnectId(item.connectId) || findAudioByConnectId(item.connectedWith);
    },
    checkLineCorrectStatus(line) {
      return this.rules.some(
        (rule) =>
          (line.connectId === rule.connectId && line.connectedWith === rule.connectedWith) ||
          (line.connectId === rule.connectedWith && line.connectedWith === rule.connectId)
      );
    },
    colorCopyLines(copyLines) {
      if (this.rules) {
        for (const line of copyLines) {
          const ruleMatched = this.checkLineCorrectStatus(line);
          line.color = ruleMatched ? this.getGoodColorLine(line.connectId) : this.getIncorrectLineColor(line);
        }
      } else {
        for (const line of copyLines) {
          if (line.connectId === line.connectedWith) {
            line.color = this.getGoodColorLine(line.connectId);
          } else {
            if (!this.dontCheckIncorrectLines) {
              line.color = this.getBadColorLine(line.connectId);
            }
          }
        }
      }
      return copyLines;
    },
    getGoodColorLine(id) {
      const { good } = this.linesColors;
      const currentConnectedItem = this.items.filter((el) => el.connectId === id)[0];
      if (!currentConnectedItem?.linesStyle?.colors?.good) return good;
      return currentConnectedItem?.linesStyle?.colors?.good;
    },
    getBadColorLine(id) {
      const { bad } = this.linesColors;
      const currentConnectedItem = this.items.filter((el) => el.connectId === id)[0];
      if (!currentConnectedItem?.linesStyle?.colors?.bad) return bad;
      return currentConnectedItem?.linesStyle?.colors?.bad;
    },
    autoCheckAction() {
      //TODOO trzeba uprościć sprawdzanie :)
      let copyLines = _.cloneDeep(this.lines);
      //kolorowanie kopiowanych linii do sprawdzenia
      copyLines = this.colorCopyLines(copyLines);
      const areThereAnyWrongAnswers = copyLines.some((line) => {
        return line.color !== this.getGoodColorLine(line.connectId);
      });
      const goodAnswersLength = copyLines.filter((line) => {
        return line.color === this.getGoodColorLine(line.connectId);
      }).length;

      let declaratedNumberOfGoodAnswers = 1;
      if (this.rules) {
        declaratedNumberOfGoodAnswers = this.rules.length;
      } else if (this.startGameConfig.numberOfGoodLines) {
        declaratedNumberOfGoodAnswers = this.startGameConfig.numberOfGoodLines;
      }

      const allLinesGoodWithoutBadOrNeutralLines =
        declaratedNumberOfGoodAnswers === goodAnswersLength && !areThereAnyWrongAnswers;

      if (allLinesGoodWithoutBadOrNeutralLines) {
        // return true;
        this.$store.dispatch('checkGame', true);
      }
    },

    checkGameAction() {
      //TODOO trzeba uprościć sprawdzanie :)
      let copyLines = _.cloneDeep(this.lines);
      //kolorowanie kopiowanych linii do sprawdzenia
      copyLines = this.colorCopyLines(copyLines);

      const areThereAnyWrongAnswers = copyLines.some((line) => {
        return line.color !== this.getGoodColorLine(line.connectId);
      });
      const goodAnswersLength = copyLines.filter((line) => {
        return line.color === this.getGoodColorLine(line.connectId);
      }).length;

      let declaratedNumberOfGoodAnswers = 1;
      if (this.rules) {
        declaratedNumberOfGoodAnswers = this.rules.length;
      } else if (this.startGameConfig.numberOfGoodLines) {
        declaratedNumberOfGoodAnswers = this.startGameConfig.numberOfGoodLines;
      }

      const allLinesGoodWithoutBadOrNeutralLines =
        declaratedNumberOfGoodAnswers === goodAnswersLength && !areThereAnyWrongAnswers;

      if (allLinesGoodWithoutBadOrNeutralLines) {
        // jeśli wszystko się zgadza kopiuje linie i daje true
        this.lines = [...copyLines];
        return true;
      } else {
        if (this.startGameConfig.deleteAllLines) {
          setTimeout(() => {
            this.lines = [];
            copyLines = [];
            this.disableClick = false;
          }, 500);
          return false;
        }
        if (this.checkIfAllCorrect) {
          // jeśli checkIfAllCorrect kasuje wszystkie złe linie (neutralne i bad)
          // nie koloruje przy tym oryginalnych linii
          this.disableClick = true;
          setTimeout(() => {
            this.deleteBadLines();
            this.disableClick = false;
          }, 500);
          return false;
        } else {
          // jeśli nie ma flagi checkIfAllCorrect - koloruje oryginalne linie
          this.lines = [...copyLines];
        }
        if (!this.dontCheckIncorrectLines) {
          // jeśli nie ma flagi dontCheckIncorrectLines usuwa złe linie
          // bo jeśli jest ta flaga to nie mamy czerwonych linii tylko neutralne i ich nie usuwamy
          this.disableClick = true;
          setTimeout(() => {
            this.deleteBadLines();
            this.disableClick = false;
          }, 1000);
        }

        return false;
      }
    },
    /**
     * czyszczenie tablic connectedLinesIds w itemach - usuwa się id lini, które zostały usunięte
     * @method clearItemsConnectedLinesIds
     */
    clearItemsConnectedLinesIds() {
      this.items = this.items.map((item) => {
        if (item.connectedLinesIds) {
          let newConnectedLinesIds = item.connectedLinesIds.filter((lineId) => {
            return this.lines.some((line) => {
              return line.id === lineId;
            });
          });
          item.connectedLinesIds = newConnectedLinesIds ? newConnectedLinesIds : [];
        }
        return item;
      });
    },
    removeLine(id) {
      if (this.findLineIndex(id) != -1) {
        this.lines.splice(this.findLineIndex(id), 1);
      }
      this.clearItemsConnectedLinesIds();
    },

    /**
     * Find two nearest hook points from source item and target item
     * @method chooseNearestHooks
     */
    chooseNearestHooks(sourceItem, sourceHooks, targetItem, targetHooks) {
      let sourceItemHooksAbsolutePosition = sourceHooks.map((hook) => {
        return {
          xAbsolute: hook.x + sourceItem.pos.x,
          x: hook.x,
          yAbsolute: hook.y + sourceItem.pos.y,
          y: hook.y,
        };
      });
      let targetItemHooksAbsolutePosition = targetHooks.map((hook) => {
        return {
          xAbsolute: hook.x + targetItem.pos.x,
          x: hook.x,
          yAbsolute: hook.y + targetItem.pos.y,
          y: hook.y,
        };
      });
      let minDistance = Infinity;
      let closestPoints = {};

      for (let sourcePoint of sourceItemHooksAbsolutePosition) {
        for (let targetPoint of targetItemHooksAbsolutePosition) {
          let distance = Math.sqrt(
            Math.pow(targetPoint.xAbsolute - sourcePoint.xAbsolute, 2) +
              Math.pow(targetPoint.yAbsolute - sourcePoint.yAbsolute, 2)
          );
          if (distance < minDistance) {
            minDistance = distance;
            closestPoints.source = { x: sourcePoint.x, y: sourcePoint.y };
            closestPoints.target = { x: targetPoint.x, y: targetPoint.y };
          }
        }
      }

      return closestPoints;
    },

    giveMeGroupPlease(id) {
      return this.items.find((item) => item.connectId === id).group;
    },

    checkIfLineCanBeConnected(currentLine, lines, sourceItem, targetItem) {
      //sprawdzam czy połączone itemy nie należą do grup wykluczonych
      if (this.startGameConfig.disableConnectGroups) {
        for (let i = 0; i < this.startGameConfig.disableConnectGroups.length; i++) {
          const pair = this.startGameConfig.disableConnectGroups[i];

          if (
            (sourceItem.group === pair[0] && targetItem.group === pair[1]) ||
            (sourceItem.group === pair[1] && targetItem.group === pair[0])
          ) {
            return false;
          }
        }
      }
      if (sourceItem.group === targetItem.group) {
        return false;
      }

      if (sourceItem?.maxNumberOfLinesWithOtherGroup) {
        const targetGroup = this.giveMeGroupPlease(targetItem.connectId);
        const count = this.lines.reduce((accumulator, element) => {
          if (
            (element.connectId === sourceItem.connectId &&
              this.giveMeGroupPlease(element.connectedWith) === targetGroup) ||
            (this.giveMeGroupPlease(element.connectId) === targetGroup &&
              element.connectedWith === sourceItem.connectId)
          ) {
            return accumulator + 1;
          }
          return accumulator;
        }, 0);
        if (count > sourceItem?.maxNumberOfLinesWithOtherGroup) {
          return false;
        }
      }
      if (targetItem?.maxNumberOfLinesWithOtherGroup) {
        const sourceGroup = this.giveMeGroupPlease(sourceItem.connectId);
        const count2 = this.lines.reduce((accumulator, element) => {
          if (
            (this.giveMeGroupPlease(element.connectId) === sourceGroup &&
              element.connectedWith === targetItem.connectId) ||
            (element.connectId === targetItem.connectId &&
              this.giveMeGroupPlease(element.connectedWith) === sourceGroup)
          ) {
            return accumulator + 1;
          }
          return accumulator;
        }, 0);
        if (count2 > targetItem?.maxNumberOfLinesWithOtherGroup) {
          return false;
        }
      }

      //sprawdzam czy element, do którego zostanie poprowadzona linia nie jest przykryty maską
      if (this.maskData.length > 0) {
        const isCovered =
          this.maskData.filter((item) => item.id === targetItem.audio && item.isWrapped === true).length > 0;
        if (isCovered) return false;
      }

      //sprawdzam czy nie istnieje już taka sama linia - jeśli tak to usuwam aktualną łączoną
      const pairExists = lines.some((line) => {
        return (
          (line.x1 === currentLine.x1 &&
            line.y1 === currentLine.y1 &&
            line.x2 === currentLine.x2 &&
            line.y2 === currentLine.y2) ||
          (line.x2 === currentLine.x1 &&
            line.y2 === currentLine.y1 &&
            line.x1 === currentLine.x2 &&
            line.y1 === currentLine.y2)
        );
      });

      return !pairExists;
    },
    /**
     * method runs on mouseUp - end connection process
     * @method endConnect
     */
    endConnect(event, currentLineId, touch) {
      if (this.drag) {
        let connected = false;
        let connectedLine = null;
        let currentConnectedId = null;
        let mousePosition = { x: event.offsetX, y: event.offsetY };
        if (touch) {
          let rect = document.getElementById('ps-connect')?.getBoundingClientRect();
          mousePosition = {
            x: (1920 * ((event.changedTouches[0].clientX / rect.width) * 100)) / 100,
            y: (1080 * ((event.changedTouches[0].clientY / rect.height) * 100)) / 100,
          };
        }

        this.items.forEach((item) => {
          //** sprawdzanko czy pozycja myszy znajduje się nad obszarem itemu */
          if (
            mousePosition.x > item.pos.x &&
            mousePosition.x < item.pos.x + item.pos.width &&
            mousePosition.y > item.pos.y &&
            mousePosition.y < item.pos.y + item.pos.height &&
            item.id != currentLineId
          ) {
            let closestHooks = this.chooseNearestHooks(
              this.currentSourceItem,
              this.currentSourceItem.hooks,
              item,
              item.hooks
            );

            let linesCopy = _.cloneDeep(this.lines);
            let currentLine = this.lines[this.findLineIndex(currentLineId)];
            currentLine.x2 = item.pos.x + closestHooks.target.x;
            currentLine.y2 = item.pos.y + closestHooks.target.y;
            currentLine.x1 = this.currentSourceItem.pos.x + closestHooks.source.x;
            currentLine.y1 = this.currentSourceItem.pos.y + closestHooks.source.y;
            currentConnectedId = item.connectId;
            currentLine.connectedWith = currentConnectedId;
            if (this.checkIfLineCanBeConnected(currentLine, linesCopy, this.currentSourceItem, item)) {
              connected = true;
              if (!this.multiconnect) {
                this.items[this.findItemIndex(item.id)].connectedLinesIds.forEach((lineId) => {
                  this.removeLine(lineId);
                });
              }

              if (this.dontAcceptIncorrectLines) {
                if (!this.checkLineCorrectStatus(currentLine)) {
                  if (this.findLineIndex(currentLineId) != -1) {
                    this.lines[this.findLineIndex(currentLineId)].color = this.getBadColorLine(currentLine.connectId);
                    setTimeout(() => {
                      this.removeLine(currentLineId);
                    }, this.audioSounds['endConnect']._duration * 1000 + 100);
                  }
                  return;
                } else
                  this.lines[this.findLineIndex(currentLineId)].color = this.getGoodColorLine(currentLine.connectId);
              }

              connectedLine = currentLine;
              this.items[this.findItemIndex(item.id)].connectedLinesIds.push(currentLineId);
              this.$set(this.lines, this.findLineIndex(currentLineId), currentLine);
              this.clearItemsConnectedLinesIds();
            }
          }
        });

        if (connected && this.audioSounds) {
          const audioID = connectedLine ? this.getAudioIDOfCurrentConnection(connectedLine) : null;
          const audioToPlay =
            audioID && this.audioSounds[audioID] ? this.audioSounds[audioID] : this.audioSounds['endConnect'];
          audioToPlay?.play();
        }
        // this.lines[this.findLineIndex(currentLineId)].connectedWith = currentConnectedId; //id to currentLineId czyli id itemu z którego wychodzi linia - currentConnectedID to id itemu na którym skończono przeciąganie
        if (!connected && this.drag == true) {
          //** usuniecie lini ktore sa 'w powietrzu' odkliknelismy myszka a linia nie jest na zadnym kartoniku */
          if (this.findLineIndex(currentLineId) != -1) {
            this.removeLine(currentLineId);
          }
        }
      }
      if (this.autoCheck) {
        this.autoCheckAction();
      }

      this.drag = false;
    },

    moveLine(event, id, touch) {
      if (this.drag == true) {
        // console.log('moveLine', e);
        let currentLine = this.lines[this.findLineIndex(id)];
        currentLine.x2 = event.offsetX;
        currentLine.y2 = event.offsetY;
        if (touch) {
          let rect = document.getElementById('transparent-container')?.getBoundingClientRect();
          // console.log('rect', rect);
          currentLine.x2 = (1920 * ((event.targetTouches[0].clientX / rect.width) * 100)) / 100;
          currentLine.y2 = (1080 * ((event.targetTouches[0].clientY / rect.height) * 100)) / 100;
          // console.log('x2', currentLine.x2, 'y2', currentLine.y2);
          //currentLine.x2 = Math.round(((e.targetTouches[0].clientX - rect.left) / rect.width) * 100);
          //currentLine.y2 = Math.round(((e.targetTouches[0].clientY - rect.top) / rect.height) * 100);
        }
        this.$set(this.lines, this.findLineIndex(id), currentLine);
      }
    },
    findLineIndex(id) {
      return this.lines.findIndex((line) => line.id == id);
    },
    findItemIndex(id) {
      return this.items.findIndex((line) => line.id == id);
    },

    getRandomId() {
      let letters = '0123456789ABCDEFGHIJKLMNOPRSTUW';
      let id_0 = '';
      let id_1 = '';
      let id_2 = '';
      for (let i = 0; i < 6; i++) {
        id_0 += letters[Math.floor(Math.random() * 31)];
        id_1 += letters[Math.floor(Math.random() * 31)];
        id_2 += letters[Math.floor(Math.random() * 31)];
      }
      return id_0 + '-' + id_1 + '-' + id_2;
    },
    /**
     * choose nearest hook from item - using on start connecting process
     * @method chooseSourceHook
     */
    chooseSourceHook(mousePosition, itemHooks, item) {
      let closestHook = null;
      let shortestDistance = Infinity;

      itemHooks.forEach((hook) => {
        const distance = Math.sqrt(
          Math.pow(mousePosition.x + item.pos.x - (hook.x + item.pos.x), 2) +
            Math.pow(mousePosition.y + item.pos.y - (hook.y + item.pos.y), 2)
        );
        if (distance < shortestDistance) {
          shortestDistance = distance;
          closestHook = hook;
        }
      });

      return closestHook;
    },
    /**
     * set starting position of item that you clicked - start connecting process
     * @method setStartPosition
     */
    setStartPosition(event, connectId, itemPosX, itemPosY, itemHooks, item, touch) {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
      this.audioSounds['startConnect']?.play();
      if (!this.disableClick) {
        //startowa pozycja do przeciągania lini

        this.currentLineId = this.getRandomId();
        this.currentSourceItem = item;
        let mousePosition = { x: event.offsetX, y: event.offsetY };
        if (touch) {
          let rect = event.target.getBoundingClientRect();
          let rect2 = document.getElementById('ps-connect')?.getBoundingClientRect();
          mousePosition = {
            x: (1920 * (((event.targetTouches[0].pageX - rect.left) / rect2.width) * 100)) / 100,
            y: (1080 * (((event.targetTouches[0].pageY - rect.top) / rect2.height) * 100)) / 100,
            // x: event.targetTouches[0].pageX - rect.left,
            // y: event.targetTouches[0].pageY - rect.top,
          };
          // mousePosition = { x: event.targetTouches[0].clientX, y: event.targetTouches[0].clientY };
        }

        let selectedHook = this.chooseSourceHook(mousePosition, itemHooks, item);

        //usuwam wszystkie linie polaczone do kartonika, ktory kliknales
        if (!this.multiconnect) {
          this.lines = this.lines.filter((line) => {
            return item.connectedLinesIds.every((id) => {
              return line.id !== id;
            });
          });
        } else {
          if (
            this.items[this.findItemIndex(item.id)].maxNumberOfLines &&
            this.items[this.findItemIndex(item.id)].connectedLinesIds.length ==
              this.items[this.findItemIndex(item.id)].maxNumberOfLines
          ) {
            //jeśli liczba linii wychodzących z kartonika jest równa maxNumberOfLines, usuwam ostatnią linię
            this.lines = this.lines.filter(
              (line) => line.id !== this.items[this.findItemIndex(item.id)].connectedLinesIds.at(-1)
            );
          }
        }
        //dodanie do itemu id linii aktualnie rysowanej
        this.items[this.findItemIndex(item.id)].connectedLinesIds.push(this.currentLineId);
        this.lines.push({
          id: this.currentLineId,
          x1: itemPosX + selectedHook.x,
          y1: itemPosY + selectedHook.y,
          x2: itemPosX + selectedHook.x,
          y2: itemPosY + selectedHook.y,
          connectId: connectId,
          color: this.setLineColor(this.items[this.findItemIndex(item.id)], this.linesColors.neutral),
          lineSize: this.setLineSize(this.items[this.findItemIndex(item.id)], this.linesSize),
          connectedWith: null,
        });

        this.drag = true;
      }
    },
    setLineColor(item, globalColor) {
      if (item.linesStyle) {
        return item.linesStyle.colors.neutral;
      } else {
        return globalColor;
      }
    },
    setLineSize(item, globalSize) {
      if (item.linesStyle?.size) {
        return item.linesStyle.size;
      } else {
        return globalSize;
      }
    },

    /**
     * ugly staticText style inveded by Tomasz Rzonka :)
     * @method getStaticTextStyle
     */
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.ps-connect {
  font-family: $gameFontFamily;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background: white;
  .item-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .item-container {
    cursor: pointer;

    opacity: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    background: white;
    border-radius: 10px;
    width: 200px;
    height: 100px;
    .circle {
      position: absolute;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
      background: #000000;
      background-image: linear-gradient(to top left, #000000, white);
      border-radius: 50%;
      width: 30px;
      height: 30px;
    }

    .text-container {
      position: absolute;
      font-size: 35px;
    }
  }
  .check-game-container {
    position: absolute;
    width: 100px;
    height: 100px;
    left: 1600px;
    top: 800px;
    z-index: 100;
    cursor: pointer;
    transition: 0.5s all;
  }
  .check-game-container:hover {
    transform: scale(1.1);
  }
  .transparent-container {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 4;
  }
}
svg {
  position: absolute;
  display: block;
  z-index: 1;
  left: 0px;
  top: 0px;
}
</style>
